module.exports = {
  "general.days": "días",
  "general.day": "Día",
  "general.select-days": "Seleccionar días",
  "general.select-day": "Seleccionar día",
  "general.selected-days": "Días seleccionados",
  "general.selected-day": "Día seleccionado",
  "general.date": "Fecha",
  "general.country": "País",
  "general.continue": "Continuar",
  "Info": "Información",
  "Request": "Solicitar",
  "Notifications": "Avisos",
  "Account": "Cuenta",
  "Hotel amenities and services": "Amenities y servicios del hotel",
  "To be able to enjoy our hotel more, see here the communities that we have":
    "Para poder disfrutar más de nuestro hotel vea aquí las comunidades de que disponemos",
  "Please check the rooms for room amenities as they may vary":
    "Por favor, consulte las habitaciones para conocer las comodidades de la habitación, ya que pueden variar",
  "In order to enjoy our hotel more, we have the following precautions against covid":
    "Para poder disfrutar más de nuestro hotel contamos con las siguientes prevenciones contra el covid",
  "ID Code": "Código de Seguridad",
  "Validate Code": "Validar Código",
  "general.key_explanation": "Esta clave será provista por el conserje",
  "general.reservation": "Reserva",
  "general.guest": "Huésped",
  "general.guests": "Huéspedes",
  "general.guests.one": "1 Huésped",
  "general.guests.other": "{0} Huéspedes",
  "general.single.beds.one": "1 Cama individual",
  "general.single.beds.other": "{0} Camas individuales",
  "general.double.beds.one": "1 Cama doble",
  "general.double.beds.other": "{0} Camas dobles",
  "general.guidelines": "Pautas Generales",
  "general.interests": "Intereses",
  "general.interests_hostz": "Información",
  "general.interests_offgrid": "Intereses",
  "general.payments": "Pagos",
  "general.summary": "Resumen",
  "general.summary_offgrid": "Overview",
  "general.back": "Anterior",
  "general.buy": "Comprar",
  "general.next": "Siguiente",
  "general.next_offgrid": "Next",
  "general.checkout": "CheckOut",
  "general.confirm": "Confirmar",
  "general.clear": "Borrar",
  "general.cancel": "Cancelar",
  "general.close": "Cerrar",
  "general.save": "Guardar",
  "general.go-back": "Regresar",
  "general.stay": "Estadía",
  "general.identify-using-qr": "Identificarme usando QR",
  "general.identify-using-code": "Identificarme usando Código",
  "general.identify-welcome": "Bienvenido",
  "general.identify-welcome-phrase": "Por favor, proceda a completar el pre-check-in y nosotros tendremos todo listo para su llegada.",
  "general.identify-welcome-phrase-offgrid": "Por favor, completa tu check-in en línea lo antes posible. Recibirás la información de llegada un día antes de tu llegada.",

  "general.identify-screen.title": "Ingresá a tu asistente digital para la estadía:",
  "general.identify-screen.subtitle": "Con tu código de reserva o tus datos si ya estás en el hotel",
  "general.identify-screen.subtitle-1": "Completá los datos para continuar",
  "general.identify-screen.subtitle-2": "Por favor, complete los siguientes datos para continuar",
  "general.identify-screen.button-code": "Tengo código de reserva",
  "general.identify-screen.button-data": "Estoy alojado",
  "general.identify-screen.button-identify": "Continuar",
  "general.identify-screen.button-return-code": "Ir a identificación por código de reserva",
  "general.identify-screen.button-return-data": "Ir a identificación con datos de la reserva",
  "general.identify-screen.error-code": "No hemos podido encontrar el código de reserva indicado, por favor, vuelva a intentar!",
  "general.identify-screen.error-data": "No hemos podido encontrar la reserva con los datos indicados, por favor, vuelva a intentar!",
  "general.identify-screen.title-hostz": "Ingresá a tu asistente digital para huéspedes:",
  "general.active": "Activo",
  "general.accept": "Aceptar",
  "general.inactive": "Inactivo",
  "general.go-to-detail": "Ir al Detalle",
  "general.go_to_website": "Conocer más",
  "general.go-to-my-stay": "Ir a Mi Estadía",
  "general.price": "Precio",
  "general.report": "Reportar",
  "general.edit": "Modificar",
  "general.checkin_edit": "Editar datos del Check-in",
  "general.experiences": "Experiencias",
  "general.request": "Solicitar",
  "general.send": "Enviar",
  "general.detail": "Detalle",
  "general.no-charge": "Gratis",
  "general.yes": "SI",
  "general.no": "NO",
  "general.dateformat": "dd-MM-yyyy",
  "general.short-dateformat": "dd-MM",
  "general.chat": "Chat",
  "general.services": "Servicios",
  "general.equipment": "Equipamiento",
  "general.features": "Características",
  "general.from": "Desde",
  "general.to": "Hasta",
  "general.duration": "Duración",
  "general.today": "Hoy",
  "general.yesterday": "Ayer",
  "general.tomorrow": "Mañana",
  "general.remove": "Borrar",
  "general.upload": "Subir",
  "general.upload-file": "Subir Archivo",
  "general.balance": "Balance",
  "general.send_comment": "Enviar Comentario",
  "general.menu": "Cartas de Menu",
  "general.start.checkin": "Comenzar Check-in",
  "general.placeOrder": "Generar Pedido",
  "general.updateOrder": "Actualizar Pedido",
  "general.please": "Por favor",
  "general.touch": "Por favor, selecciona la opción ",
  "general.total": "Total",
  "general.hour": "Hora",
  "general.time": "Hora",
  "general.qty": "Cant.",
  "general.reserve": "Reservar",
  "general.selected": "Seleccionado",
  "general.time-format": " hs",
  "general.select-date": "Por favor, selecciona la fecha, hora y cantidad de personas para su reserva",
  "general.no-schedule-available": "No hay horario disponible",
  "general.fields_required": "son campos requeridos",
  "general.about": "Acerca de",
  "general.type_message": "Escribe tu mensaje...",
  "general.items.qty": "Cant. Items",
  "general.notifications": "Notificaciones",
  "general.notifications_description": "Tus configuraciones personales en esta aplicación para personalizar tu experiencia.",
  "general.add-to-home-screen-text": "Puedes agregar esta página a tu pantalla de inicio para acceder rápidamente.",
  "general.add-to-home-screen-button": "Agregar a la pantalla de inicio",
  "general.hs": "hs.",
  "general.hs-abrev": "hs.",
  "general.min": "min.",
  "general.select_option": "Seleccione una opción...",
  "general.customization": "Configure su add-on...",
  "kiosk.back": "Volver",
  "hotel.website": "Sitio Web",
  "hotel.phones": "Teléfonos",
  "hotel.address": "Dirección",
  "hotel.contact-us": "Contacte con nosotros",
  "hotel.social-networks": "Redes Sociales",
  "hotel.please-feel": "Puede comunicarse con nosotros siempre que lo desee.",
  "hotel.conditioning-air-in-common-spaces":
    "Aire acondicionado en espacios comunes",
  "hotel.location": "Ubicación",
  "hotel.parking": "Estacionamiento",
  "hotel.free-parking": "Estacionamiento gratuito",
  "hotel.pay-parking": "Estacionamiento pago",
  "hotel.bar": "Bar",
  "hotel.aesthetic-center": "Centro de estética",
  "hotel.kids-club": "Club para niños",
  "hotel.luggage-storage": "Consigna de equipaje",
  "hotel.breakfast": "Desayuno",
  "hotel.breakfast-buffet": "Desayuno Buffet",
  "hotel.smoke-free-space": "Espacio libre de humo",
  "hotel.fitness-center": "Fitness center",
  "hotel.gay-friendly": "Gay Friendly",
  "hotel.hydromassage": "Hidromasaje",
  "hotel.gardens": "Jardines",
  "hotel.masseuse-available": "Masajista disponible",
  "hotel.water-park": "Parque acuático",
  "hotel.hairdressing": "Peluquería",
  "hotel.bilingual-staff-english-spanish": "Personal bilingüe (Inglés/Español)",
  "hotel.pet-friendly": "Pet Friendly",
  "hotel.pool": "Piscina",
  "hotel.smoking-points": "Puntos de fumador",
  "hotel.reception-24-hs": "Recepción 24hs",
  "hotel.restaurant": "Restaurante",
  "hotel.restaurant-to-the-card": "Restaurante a la carta",
  "hotel.theme-restaurant": "Restaurante temático",
  "hotel.congress-hall": "Sala de congresos",
  "hotel.meeting-room": "Sala de reuniones",
  "hotel.sauna": "Sauna",
  "hotel.laundry-service": "Servicio de Lavandería",
  "hotel.babycare-service": "Servicio de Guardería",
  "hotel.spa": "Spa",
  "hotel.theater": "Teatro",
  "hotel.terraces": "Terrazas",
  "hotel.souvenir-shop": "Tienda de souvenirs",
  "hotel.airport-transfer": "Traslados al Aeropuerto a demanda",
  "hotel.covid.protected-medical-area": "Area médica protegida",
  "hotel.covid.virtual-check-in-out": "Check in / out virtual",
  "hotel.covid.temperature-check": "Chequeo de temperatura",
  "hotel.covid.first-aid-kit-available": "Kit de primeros auxilios disponibles",
  "hotel.covid.separation-screens-for-personnel":
    "Mamparas de separacion para personal",
  "hotel.covid.contactless-payment-available": "Pago sin contacto disponible",
  "hotel.covid.sanitizers-in-common-areas": "Sanitizantes en áreas comunes",
  "hotel.covid.use-of-specific-cleaning-articles-for-covid":
    "Utilización de articulos de limpieza específicos para Covid",
  "meeting_rooms.dvd-player": "Reproductor de DVD",
  "meeting_rooms.high-speed-wi-fi": "WIFI de alta velocidad",
  "meeting_rooms.independent-access": "Acceso Independiente",
  "meeting_rooms.lunch-service": "Servicio de Lunch",
  "meeting_rooms.meeting-room": "Sala de Reunión",
  "meeting_rooms.megaphone": "Megafono",
  "meeting_rooms.microphone": "Microfono",
  "meeting_rooms.smart-tv": "Smart TV",
  "meeting_rooms.video-projection": "Video Proyector",
  "meeting_rooms.capacity": "Capacidad:",
  "meeting_rooms.people": "personas.",
  "room-categories.air-conditioning": "Aire acondicionado",
  "room-categories.complimentary-dressing": "Vestidor de cortesía",
  "room-categories.work-area": "Área de trabajo",
  "room-categories.private-balcony": "Balcón privado",
  "room-categories.cable": "Cable",
  "room-categories.safe-box": "Caja fuerte",
  "room-categories.sommier-beds": "Camas sommier",
  "room-categories.room": "Habitación",
  "room-categories.hydromassage": "Hidromasaje",
  "room-categories.coffee-machine": "Máquina de café",
  "room-categories.minibar": "Minibar",
  "room-categories.hairdryer": "Secador de pelo",
  "room-categories.selection-of-pillows": "Selección de almohadas",
  "room-categories.ironing-service": "Servicio de planchado",
  "room-categories.smart-tv": "Smart TV",
  "room-categories.king-size-bed": "Cama king size",
  "room-categories.phone": "Teléfono",
  "room-categories.tv-lcd": "TV LCD",
  "room-categories.satellite-tv": "TV satelital",
  "room-categories.street-view": "Vista a la calle",
  "room-categories.garden-view": "Vista al jardín",
  "room-categories.sea-view": "Vista al mar",
  "room-categories.wifi": "Wifi",
  "room-categories.ketle": "Pava eléctrica",
  "room-categories.fridge": "Refrigerador",
  "room-categories.dishwasher": "Lavavajillas",
  "room-categories.oven": "Horno",
  "room-categories.freezer": "Congelador",
  "room-categories.water-heater": "Calentador de agua",
  "room-categories.plates-glasses": "Platos y vasos",
  "room-categories.cutlery-dishes": "Cubiertos y platos",
  "room-categories.microwave": "Microondas",
  "room-categories.kettle": "Pava eléctrica",
  "room-categories.nespresso-machine": "Máquina Nespresso",

  "room-categories.toilette-with-shower-box": "Toilette de Recepción con box de ducha",
  "room-categories.sofa-bed": "Sofá cama",
  "room-categories.partial-sea-view": "Vista parcial al mar",
  "room-categories.welcome-amenities": "Amenities de bienvenida",
  "room-categories.shower": "Ducha",
  "room-categories.bathtub": "Bañera",
  "room-categories.double-sink": "Doble lavabo",
  "room-categories.connected-rooms": "Conectadas",
  "room-categories.king-or-twin-beds": "Cama King o 2 camas de una plaza",
  "room-categories.los-troncos-view": "Vista a barrio Los Troncos",
  "room-categories.daily-courtesy-water": "Aguas diarias de cortesía",
  "room-categories.daily-courtesy-capsule-dilmah": "Cortesía diaria de cápsula o infusión Dilmah",
  "room-categories.stay-courtesy-capsule-dilmah": "Cortesía de cápsula o infusión Dilmah por estadía",

  "here": "aquí",

  "checkin.checkin.preparing-title": "Preparando su Check-In",
  "checkin.checkin.preparing-text": "Por favor, no cierre ni actualice esta ventana.",

  "checkin.status": "Estado del Check-in",
  "checkin.status-pending": "Pendiente",
  "checkin.status-observed": "Observado",
  "checkin.status-to_validate": "Por Validar",

  "checkin.status-to_validate-text--":
    "<b>Eso es todo por ahora!</b> Revisaremos la información y le enviaremos una notificación de confirmación. Muchas gracias!",
  "checkin.status-to_validate-text": "<b>¡Eso es todo por ahora!</b> Gracias por completar el web check-in. Saludos cordiales",

  "checkin.status-in_progress": "En Proceso",
  "checkin.status-accepted": "Aceptado",
  "checkin.status-accepted-text":
    "<b>Su Check-in fue realizado con éxito!</b> Lo estaremos esperando! Que tenga un buen viaje!",
  "checkin.status-no_show": "No Show",
  "checkin.status-no_show-text":
    "Utilice el chat a continuación en caso de que desee reprogramar su reserva original. Esperamos tenerlo con nosotros próximamente!",
  "checkin.status-canceled": "Cancelado",
  "checkin.status-canceled-text":
    "¡Su reserva ha sido cancelada! Póngase en contacto con nosotros utilizando el botón de chat a continuación si cree que se trata de un error o si desea modificar su reserva. ¡Gracias!",
  "checkin.status-done": "Checked Out",
  "checkin.status-done-text":
    "¡Su estadía ha sido completada! Póngase en contacto con nosotros utilizando el botón de chat a continuación. ¡Gracias!",

  "checkin.please-complete":
    "Por favor, complete la información solicitada y evite esperas al momento de ingresar. Si ya tiene un check-in cargado puede identificarse",
  "checkin.not-forget":
    "No olvide que si viaja con más personas deberá ingresar también sus datos para completar el check in.",
  "checkin.initiated": "Mi Check-in",
  "checkin.stay": "Estadía",
  "checkin.in": "Fecha Ingreso",
  "checkin.out": "Fecha Egreso",
  "checkin.travel-type": "Tipo de Viaje",
  "checkin.request-photos":
    "Asegúrese de que las imágenes estén enfocadas y sean legibles. Puede recortar y cambiar el tamaño de las imágenes después de tomarlas.",
  "checkin.inputs.select": "Seleccione...",
  "checkin.inputs.dni-number": "Número",
  "checkin.inputs.dni-number-offgrid": "Número",
  "checkin.inputs.email": "Email",
  "checkin.inputs.travelType": "Tipo de Viaje",
  "checkin.inputs.dni-issue-date": "Fec. Emisión",
  "checkin.inputs.dni-issue-date-offgrid": "Fec. Emisión",
  "checkin.inputs.dni-issue-date-simplex": "Fec. Emisión",
  "checkin.inputs.dniIssueDate": "Fec. Emisión",
  "checkin.inputs.dniIssueDate-offgrid": "Fec. Emisión",
  "checkin.inputs.dniIssueDate-simplex": "Fec. Emisión",
  "checkin.inputs.name": "Nombre",
  "checkin.inputs.surname": "Apellido",
  "checkin.inputs.gender": "Género...",
  "checkin.inputs.gender.male": "Masculino",
  "checkin.inputs.gender.female": "Femenino",
  "checkin.inputs.gender.other": "Otro",
  "checkin.inputs.date-of-birth": "Fec. Nac.",
  "checkin.inputs.address": "Dirección",
  "checkin.inputs.postal-code": "CP",
  "checkin.inputs.nationality": "Nacionalidad",
  "checkin.inputs.residence": "Residencia",
  "checkin.inputs.country_of_residence": "País de Residencia",
  "checkin.inputs.city": "Ciudad",
  "checkin.inputs.dniType": "Tipo de ID",
  "checkin.inputs.zipCode": "Código postal",
  "checkin.inputs.dni": "Número de ID",
  "checkin.inputs.birthday": "Fec. Nac.",
  "checkin.inputs.phone": "Telefono",
  "checkin.inputs.passenger": "Datos del pasajero",
  "checkin.inputs.photos_dniFront": "Frente DOC",
  "checkin.inputs.photos_dniBack": "Dorso DOC",
  "checkin.document-info": "Información del Documento",
  "checkin.personal-info": "Datos Personales",
  "checkin.location": "Ubicación",
  "checkin.inputs.photos_selfie": "Selfie",

  "checkin.identificate": "Identificarme",

  "checkin.passenger": "Viajante",
  "checkin.passengers": "Viajantes",
  "checkin.passengers-list": "Lista de Viajantes",
  "checkin.passengers-error-incomplete":
    "Debe completar los datos del viajante",
  "checkin.arrivalMode": "Modo de llegada",
  "checkin.arrivalMode-hostz": "Como llegará?",
  "checkin.arrivalMode-text": "Por favor, selecciona el modo de llegada",
  "checkin.arrivalMode.airplane": "Avión",
  "checkin.arrivalMode.public_transportation": "Transporte público (autobús/tren)",
  "checkin.arrivalMode.train": "Tren",
  "checkin.arrivalMode.bus": "Autobús",
  "checkin.arrivalMode.car": "Coche",
  "checkin.arrivalMode.other": "Otro",
  "checkin.add-passenger": "Agregar pasajero",
  "checkin.reservation-data": "Datos de la Reserva",
  "checkin.reviewing":
    "En breve recibirás una notificación sobre el <b>estado de tu solicitud</b>. Recuerda que aún puedes modificar la información ingresada.",
  "checkin.remember-can": "---",
  "checkin.can-see": "---",
  "checkin.please-read-to-change":
    "Por favor, revisa la observación detallada más abajo y realiza los cambios solicitados.",
  "checkin.modify": "Modificar",
  "checkin.edit-data": "Editar Datos",
  "checkin.accept": "Aceptar",
  "checkin.save-checkin": "Guardar Check-In",
  "checkin.save-changes": "Guardar Cambios",
  "checkin.update-info": "Actualizar Información",
  "checkin.dni-front": "Frente DOC",
  "checkin.dni-back": "Dorso DOC",
  "checkin.camera": "Cámara",
  "checkin.date-of-birth": "Fecha Nac.",
  "checkin.age": "Edad",
  "checkin.add-comment": "Agregar comentario",
  "checkin.me": "Yo",
  "checkin.new-checkin": "Nuevo Check-In",
  "checkin.accepted-text":
    "<b>¡Su Check-In ha sido realizado satisfactoriamente!</b> ¡Lo estaremos esperando con todo preparado para que pueda ingresar sin esperas!",
  "checkin.canceled-text":
    "<b>Su Check-In ha sido cancelado.</b> Por favor, lea los comentarios más abajo para saber cómo proceder. Muchas gracias!",
  "checkin.use-button-to-add-guest":
    "Use el botón de abajo para agregar otros viajantes.",
  "checkin.identified": "Check-In Identificado!",
  "checkin.identify-error":
    "No hemos podido encontrar el código de reserva indicado, por favor, vuelva a intentar!",
  "checkin.time-of-arrival": "Hora de Llegada",
  "checkin.time-of-arrival-text":
    "Si ya tiene una hora estimada de llegada, infórmenos aquí. ¡Estaremos esperando por usted!",
  "checkin.time-of-arrival-text2": "Su apartamento está disponible a partir de las {0} horas.",
  "checkin.time-of-arrival-text2-offgrid": "Su habitación está disponible a partir de las {0} horas.",
  "checkin.time-of-arrival-text2-hostz": "Su apartamento está disponible a partir de las {0} horas.",
  "checkin.time-of-arrival-early-checkin":
    "Solicitar <b>Early Check-In</b> <span class='text-muted'>(sujeto a disponibilidad)</span>",
  "checkin.e-mail": "E-Mail",
  "checkin.phone": "Teléfono",
  "checkin.guest-data": "Datos de los Huéspedes",
  "checkin.guest-data-text":
    "Complete la información que falta para completar su proceso de registro en línea.",
  "checkin.guest-complete-later": "Completaré esta información más tarde.",
  "checkin.id-type.id": "DNI",
  "checkin.id-type.passport": "PASAPORTE",
  "checkin.id-type.nif": "NIF",
  "checkin.id-type.nie": "NIE",
  "checkin.type-of-travel": "Tipo de Viaje",
  "checkin.type-of-travel-text":
    "Personalizaremos tu experiencia de acuerdo a tus preferencias y necesidades.",
  "checkin.travel-type.couple": "Viaje en Pareja",
  "checkin.travel-type.congress": "Congreso",
  "checkin.travel-type.family": "Viaje Familiar",
  "checkin.travel-type.business": "Viaje de Negocios",
  "checkin.travel-type.event": "Viaje a Evento",
  "checkin.travel-type.friends": "Viaje con Amigos",
  "checkin.travel-type.relaxing": "Viaje de relajación",
  "checkin.travel-type.party": "Viaje de Fiesta",
  "checkin.travel-type.single_traveler": "Viaje Individual",
  "checkin.travel-type.leisure": "Viaje de ocio",
  "checkin.company-information": "Información de la Empresa",
  "checkin.company-information-text": "Por favor, proporcione la información de su empresa.",
  "checkin.company-name": "Nombre",
  "checkin.company-name-placeholder": "Ingrese el nombre",
  "checkin.company-address": "Dirección",
  "checkin.company-address-placeholder": "Ingrese la dirección",
  "checkin.company-country": "País",
  "checkin.company-country-placeholder": "Seleccione el país",
  "checkin.company-zip-code": "Código Postal",
  "checkin.company-zip-code-placeholder": "Ingrese el código postal",
  "checkin.company-city": "Ciudad",
  "checkin.company-city-placeholder": "Ingrese la ciudad",
  "checkin.redirecting": "Redireccionando en {0} segundos...",
  "checkin.room-preferences": "Preferencia de Habitación",
  "checkin.room-preferences-text":
    "¿Tienes alguna preferencia para tu habitación? <br />Háganos saber aquí:",
  "checkin.room-preferences.close-to-elevator": "Cerca del ascensor",
  "checkin.room-preferences.far-from-elevator": "Lejos del ascensor",
  "checkin.room-preferences.wheelchair-accessible":
    "Accesible con silla de ruedas",
  "checkin.room-preferences.lower-floor": "Habitación en un piso bajo",
  "checkin.room-preferences.higher-floor": "Habitación en un piso alto",
  "checkin.take-care-environment":
    "¿Quieres ayudar a cuidar el medio ambiente?",
  "checkin.take-care-environment-text":
    "Las cosas pequeñas pueden reducir significativamente su huella ambiental durante su estadía.",
  "checkin.take-care-environment.housekeeping-frequency":
    "Frecuencia de Limpieza",
  "checkin.take-care-environment.housekeeping-frequency.everyday": "Cada día",
  "checkin.take-care-environment.housekeeping-frequency.every-other-day":
    "Día por Medio",
  "checkin.take-care-environment.housekeeping-frequency.do-not-clean-my-room":
    "No limpiar mi Habitación",
  "checkin.take-care-environment.towell-replacement-frequency":
    "Frecuencia de cambio de toallas",
  "checkin.take-care-environment.towell-replacement-frequency.do-not-change":
    "No cambiar Toallas",
  "checkin.take-care-environment.towell-replacement-frequency.everyday":
    "Cada día",
  "checkin.take-care-environment.towell-replacement-frequency.every-other-day":
    "Día por Medio",
  "checkin.restaurant-reservation":
    "Estoy interesado en hacer una reserva en su/s <b>restaurante/s</b>",
  "checkin.comments": "Comentarios",
  "checkin.comments-text":
    "Háganos saber si hay algo que podamos hacer para mejorar su estadía con nosotros.",
  "checkin.review-the-summary":
    "Revise el resumen de su Check-In en línea. Puede regresar y editar cualquier información que acaba de proporcionar. Si todo es correcto, presione el botón <b>\"Confirmar\"</b> a continuación.",
  "checkin.reservation-code": "Código de Reserva",
  "checkin.in-out": "Entrada / Salida",
  "checkin.primary-guest": "Huésped Titular",
  "checkin.guests-text": "Necesitamos esta información para determinar la mejor configuración de camas para su estancia y garantizar su comodidad.<br /><br /><small>Adultos (15+ años) / Niños (3-14 años) / Bebés (0-2 años)</small>",
  "checkin.adult-s": "Adulto(s)",
  "checkin.adults": "Adultos",
  "checkin.adult": "Adulto",
  "checkin.short-room": "Hab",
  "checkin.room": "Habitación",
  "checkin.do-not-disturb": "No Molestar",
  "checkin.select-door-open": "Por favor, seleccione la puerta que desea abrir...",
  "checkin.select-door-open-hostz": "Haz clic en la puerta que deseas abrir",
  "checkin.select-door-open-themyde": "Seleccione la puerta que desea abrir y deslice el botón",
  "checkin.select-photo-source-to": "Seleccione el origen para ",
  "checkin.use-camera": "Usar Cámara",
  "checkin.selfie.preview-title": "Foto Frontal",
  "checkin.selfie.preview-text": "Recorte la imagen para centrar bien su rostro.",
  "checkin.selfie.required": "Foto Selfie Requerida",
  "checkin.dniFront.preview-title": "Frente DNI",
  "checkin.dniFront.preview-text": "Recorte la imagen para centrar bien su documento.",
  "checkin.dniFront.required": "Frente DOC Requerido",
  "checkin.selfie.required": "Foto Selfie Requerida",
  "checkin.dniBack.required": "Dorso DOC Requerida",
  "checkin.the_myde_selfie_message_title": "¡Importante!",
  "checkin.dniBack.preview-title": "Dorso DNI",
  "checkin.dniBack.preview-text": "Recorte la imagen para centrar bien su documento.",
  "checkin.camera.repeat": "Repetir",
  "checkin.camera.crop": "Recortar",
  "checkin.camera.use-photo": "Usar Foto",
  "checkin.sign-and-confirm": "Firmar & Confirmar",
  "checkin.gdpr-text1": "Al firmar a continuación, doy mi consentimiento para el procesamiento de mis datos personales de acuerdo con la",
  "checkin.gdpr-text2": ". Entiendo que puedo retirar mi consentimiento en cualquier momento.",
  "checkin.gdpr-text-nexo": "y el",

  "checkin.gdpr-text1-costa": "Al firmar a continuación, autorizo el tratamiento de mis datos personales conforme a la",
  "checkin.gdpr-text2-costa": ", y declaro no ser residente fiscal en la República Argentina según la",
  "checkin.gdpr-text-nexo-costa": ", con la posibilidad de retirar mi consentimiento en cualquier momento. Asimismo, confirmo haber leído y aceptar el ",
  "checkin.gdpr-text3-costa": "Declaro que mi estadía en Argentina es por turismo y no excede el plazo permitido por ley, con fines de reintegro de IVA por ley N° 3971(AFIP) y la Resolución N° 566.",
  "checkin.gdpr-button-2-popup": "Declaro que mi estadía en la República Argentina no excede el plazo máximo que establece la legislación migratoria vigente y que mi estadía en el país es por turismo.<br />Sirva la presente Declaración Jurada a los efectos de realizar la tramitación de solicitud de reintegro del impuesto al valor agregado conforme Resolución General N° 3971(AFIP) y Resolución N° 566(Turismo)",

  "checkin.gdpr-text1-hostz": "Al firmar a continuación, doy mi consentimiento para el tratamiento de mis datos personales de acuerdo con la",
  "checkin.gdpr-text2-hostz": ".",
  "checkin.gdpr-text-nexo-hostz": " y entiendo que puedo retirar mi consentimiento en cualquier momento.<br/><br/>Reconozco y acepto cumplir con los ",

  "checkin.gdpr-text1-simplex": "Al firmar a continuación, doy mi consentimiento para el tratamiento de mis datos personales de acuerdo con la",
  "checkin.gdpr-text2-simplex": ".",
  "checkin.gdpr-text-nexo-simplex": " y entiendo que puedo retirar mi consentimiento en cualquier momento.<br/><br/>Reconozco y acepto cumplir con los ",

  "checkin.gdpr-text1-offgrid": "Al firmar a continuación, acepto el tratamiento y uso de mis datos personales de acuerdo con el",
  "checkin.gdpr-text2-offgrid": " de Offgrid Mindful Cabins.",
  "checkin.gdpr-text-nexo-offgrid": " y acepto los ",

  "checkin.gdpr-button": "Política de Privacidad",
  "checkin.gdpr-button-1": "Reglamento del Hotel",
  "checkin.gdpr-button-1-simplex": "Reglamento del Hotel",
  "checkin.gdpr-button-1-hostz": "Reglamento del Hotel",
  "checkin.gdpr-button-1-hostz-swissstay": "Reglamento",
  "checkin.gdpr-button-1-offgrid": "General Terms & Conditions",
  "checkin.gdpr-button-2": "Resolución General N° 3971 (AFIP)",

  "checkin.terms-and-conditions": "Términos y Condiciones",
  "checkin.hotel-regulations": "Reglamento del Hotel",

  "checkin.terms-and-conditions-button-detail": "de la estancia en el Hotel",
  "checkin.the_myde_selfie_message": "Por favor, suba una <b>selfie de usted sosteniendo su documento de identidad</b> (pasaporte, tarjeta de identidad o licencia de conducir). Esto nos ayuda a mantener su estancia segura y sin complicaciones.",
  "checkin.reservation-conditions-text": "La administración no se hace responsable de los objetos de valor que se dejen en la habitación.<br /><br /><b>La hora de salida es hasta las 11:00 del mediodía.</b><br /><br /><span class='text -danger font-weight-bold'>No se permite fumar en todas nuestras habitaciones ni en todas las áreas públicas.</span><br />Solo se permite fumar fuera del edificio, en la calle. Si todavía fuma en la habitación, le cobraremos una tarifa de limpieza de 250,00 euros.<br /><br /><small>Los datos mencionados anteriormente son manejados por EDP.</small>",
  "checkin.reservation-conditions-text-offgrid": "<b>Check-in:</b> a partir de las 15:00<br/><b>Check-out:</b> hasta las 11:00<br/><ul><li>Está prohibido fumar en todas nuestras cabañas.</li><li>Por favor, ten en cuenta que solo los huéspedes registrados pueden permanecer y pernoctar en la cabaña. El número máximo de huéspedes es de 2 personas.</li><li>Por favor, informa de daños y defectos de inmediato a través de “Informe de daños“ en tu guía o contáctanos a través de nuestra línea directa: +49 30 54806375.</li><li>Travel to and use of our off-grid accommodations are at your own risk; we accept no liability for weather-related restrictions, road conditions, or accidents. Detailed regulations can be found in our terms and conditions.</li></ul><br/>Un resumen de las reglas de la cabaña se encuentra en tu guía de viaje bajo “Tu cabaña“ -> “Reglas de la cabaña“.",
  "checkin.signature": "Firma",
  "checkin.please-sign-here": "Toque para firmar",
  "checkin.please-sign-below": "Por favor firme abajo",
  "checkin.confirm": "Confirmar",
  "checkin.newsletter": "Newsletter",
  "checkin.newsletter-optin": "Quiero recibir novedades y ofertas del hotel por email",
  "checkin.click-edit-data-text1": " para realizar las modificaciones necesarias. Una vez que hayas hecho los cambios, presiona ",
  "checkin.click-edit-data-text2": " y luego ",
  "checkin.click-edit-data-text3": ". ¡Agradecemos tu colaboración!",

  "checkin.floor-selection": "Selección de Piso",
  "checkin.floor-selection-text": "Por favor, seleccione el piso en el que desea hospedarse. Recuerde, no disponemos de ascensores.",
  "checkin.ground-floor": "Planta Baja",
  "checkin.first-floor": "Primer Piso",
  "checkin.indifferent": "Indiferente",
  "checkin.entry-time-not-know-yet": "Todavía no lo sé",
  "checkin.child": "Niño",
  "checkin.child-s": "Niño(s)",
  "checkin.children": "Niños",
  "checkin.no-children": "Sin Niños",
  "checkin.babies": "Bebés",
  "checkin.years": "años",

  "checkin.dniFront.required": "Frente DOC Requerido",

  "checkin.please-complete-your-checkin-title": "Check-in Pendiente",
  "checkin.please-complete-your-checkin-text": "Por favor, complete su check-in haciendo clic aquí.",
  "checkin.no.name.yet": "Nombre no provisto aún",

  "cups.title": "Add-ons",
  "cups.remove_button": "Eliminar",
  "cups.add_button": "Agregar",
  "cups.subject_to_availability": "Sujeto a disponibilidad",
  "cups.subject_to_availability_text": "Este artículo está sujeto a disponibilidad. Durante este proceso, no se incurrirá en cargos, y al seleccionarlo, un representante del hotel se pondrá en contacto con usted para proporcionarle más detalles al respecto.",
  "cups.preferedList_text": "Basado en tus intereses, tenemos estas experiencias para ti",
  "cups.otherList_text": "Quizás estas experiencias también te interesen",
  "cups.tags.best-selling": "Más vendido",
  "cups.tags.most-popular": "Más popular",
  "cups.tags.best-price": "Mejor precio",
  "cups.priceIsPerNight": "por noche",
  "cups.confirm": "¿Confirma esta compra?",
  "cups.booked": "Reservado",
  "cups.spots": "lugar(es)",

  "checkout.loading-information":
    "Por favor, espere mientras recopilo la información de su estadía.",
  "checkout.errors-title":
    "No es posible realizar el Check-out en este momento.",
  "checkout.error-balance":
    "Su cuenta tiene un saldo impago de {0}. Por favor cancele su saldo para continuar.",
  "checkout.error-departure":
    "La fecha de Check out es el día {0}.  Desea modificar su fecha de salida?",
  "checkout.button": "Proceder con el CheckOut",
  "checkout.error-departure-button": "¿Necesitas ayuda? ¡Chatea con nosotros!",
  "date.january": "Enero",
  "date.february": "Febrero",
  "date.march": "Marzo",
  "date.april": "Abril",
  "date.may": "Mayo",
  "date.june": "Junio",
  "date.july": "Julio",
  "date.august": "Agosto",
  "date.september": "Septiembre",
  "date.october": "Octubre",
  "date.november": "Noviembre",
  "date.december": "Diciembre",
  "checkout.success-title": "Su CheckOut ha sido exitoso!",
  "checkout.error-noShowBalance": "Si tienes alguna pregunta en relación a los cargos o necesitas asistencia, ¡estamos aquí para ayudarte! Simplemente haz clic en el botón de chat que encontrarás más abajo. Además, si deseas cancelar tu cuenta, puedes hacerlo directamente desde esta sección. Tu satisfacción es nuestra prioridad",
  "checkout.debt": "No podemos procesar el checkout. Su estadía tiene un saldo impago de: ",
  "checkout.pay_now": "Pagar ahora",
  "checkout.ask_for_balance": "Lamentablemente, no podemos procesar el checkout en este momento. Por favor, chatee con nosotros para obtener instrucciones adicionales.",
  "maps.how_to_reach_us": "¿Cómo llegar a nosotros?",
  "maps.get_directions": "Cómo llegar",
  "welcome.title": "¡Bienvenido a nuestro hotel!",
  "welcome.subtitle": "¡Te deseamos que tengas una excelente estadía!",
  "welcome.text":
    "<b>Mi nombre es ViCo y seré tu conserje virtual!</b> Estoy disponible para ti las 24hs del dia y puedes pedirme lo que sea que necesites! Para ello entra en la sección “Solicitar” desde donde podrás ordenar room service, solicitar la limpieza de la habitación, reposición de suministros, etc.",
  "welcome.text-costa-galana":
    "<b>Con nuestro servicio Mobile Concierge</b>, reciba una atención personalizada las 24 horas para atender sus preferencias, solicitudes y recomendaciones... <br /><br />Desde la comodidad de su dispositivo, solicite servicio de ama de llaves, room service, reservas de restaurantes y spa. <br /><br />Haga clic en 'Comenzar' e ingrese en la sección Solicitar.<br /><br />Si lo desea puede comunicarse desde la extensión 99 desde su habitación.",


  "welcome.text-belair": "<b>¡Bienvenido a Grand Brizo Bel Air!</b><br /><br />A través de este canal de comunicación estaremos disponibles las 24 horas para asistirle con cualquier necesidad que pueda surgir.<br /><br />Puede ingresar a la sección <b>“Solicitar“</b>, donde encontrará opciones para ordenar room service, reservar servicios del hotel, solicitar limpieza de habitación, entre muchas otras comodidades pensadas para usted.",
  "welcome.text-hostz-becozy": "Welcome to our Becozy Basel, you will find everything you need to make the most of your stay.<br><br>Through this portal, you can elevate your experience with our available services, explore our property, discover things to do in the area, and much more.",
  "welcome.text-hostz-san-carlo": "Welcome to our Hotel San Carlo in Lugano, you will find everything you need to make the most of your stay.<br><br>Through this portal, you can elevate your experience with our available services, explore our property, discover things to do in the area, and much more.",
  "welcome.text-hostz-blacksummit": "Welcome to Black Summit Resort in Laax! In this portal, you will find everything you need to make the most of your stay.<br><br>Through this portal, you can elevate your experience with our available services, explore our property, discover things to do in the area, and much more.",
  "welcome.text-hostz-betahouse": "Welcome! You are now checked in.",
  "welcome.text-hostz-themyde": "<br/><br/><b>¡Bienvenido! Ya estás registrado. </b>Encuentra todos tus datos de acceso en la sección de Información de acceso en tu Panel de control.<br/><br/></br/>",
  "welcome.text-hostz-arosa": "<br/><br/><b>¡Bienvenido! Ya estás registrado. </b>Encuentra todos tus datos de acceso en la sección de Información de acceso en tu Panel de control.<br/><br/></br/>",
  "welcome.text-hostz-swissstay": "Welcome! You are now checked in. You can now find all your access instructions in the Access Information section of your dashboard.",
  "welcome.text-hostz-steiners": "Welcome! You are now checked in. You can now find all your access instructions in the Access Information section of your dashboard.",

  "welcome.subtitle-offgrid": "Bienvenido a tu Guía de la Cabaña :)",
  "welcome.text-offgrid": "Aquí encontrarás todo lo que necesitas para tu estancia, desde tu  <b>check-in online</b>  e  <b>información de llegada</b>  hasta consejos útiles para tu tiempo en la cabaña.<br><br>Si tienes alguna pregunta, no dudes en contactarnos en cualquier momento, ¡estamos felices de ayudarte!<br>Para asuntos urgentes, simplemente envíanos un mensaje por  <b>WhatsApp al +49 30 54806375</b>.",
  "welcome.footer-offgrid": "👉  <b>Para un fácil acceso</b> , puedes guardar la Guía de la Cabaña en tu pantalla de inicio. Simplemente toca  <b>\"aceptar\"</b>  y arrastra el icono donde quieras. No ocupa espacio y puedes eliminarlo en cualquier momento después de tu estancia.<br><br><b>¡Que tengas una estancia maravillosa!</b>  🌿",
  "welcome.footer-belair": "Para facilitar aún más el acceso, le recomendamos crear un acceso directo en la pantalla de inicio de su teléfono. No ocupa espacio y puede eliminarlo fácilmente al finalizar su estadía.<br /><br />Estamos a su disposición para asegurarnos de que tenga una estadía agradable.<br /><br /><b>Equipo Grand Brizo Bel Air</b>",
  "welcome.room-offgrid": "Cabaña",

  "welcome.footer-hostz": "Para facilitar el acceso, le recomendamos habilitar las notificaciones y crear un acceso directo en su pantalla de inicio. Esto le ayudará a mantenerse actualizado con información importante sobre su estadía y le permitirá realizar solicitudes fácilmente para que su estadía sea aún más cómoda.",
  "welcome.footer-hostz-betahouse": "You can now find all your access instructions in the Access Information section of your dashboard.",

  "welcome.room": "Tu habitación es:",
  "welcome.room_bs": "Tu apartamento es:",
  "welcome.footer":
    "Para que me encuentres más fácilmente por favor acepta crear un acceso directo en el home de tu teléfono. No ocupa espacio y puedes eliminarlo tan pronto como te retires del hotel.<br /><br /><b>Será un placer atenderte!</b>",
  "welcome.start": "Comenzar",
  "services.type.general": "Consultas",
  "services.type.room_service": "Servicio de Hab.",
  "services.type.pool_service": "Servicio de Piscina",
  "services.type.room_supplies": "Suministros de Hab.",
  "services.type.laundry": "Lavadero",
  "services.type.porter": "Porter",
  "services.type.tray_collection": "Recolección de Bandeja",
  "services.type.pressing": "Planchado",
  "services.type.housekeeping": "Limpieza de Hab.",
  "services.type.wakeup_call": "Llamada Despertador",
  "services.type.car_valet": "Valet Parking",
  "services.type.concierge": "Conserje",
  "services.type.lost_objects": "Objetos Perdidos",
  "services.type.breakage_report": "Reporte de Daños",
  "services.type.services_booking": "Reserva de Servicios",
  "services.type.review_tracking": "Ticket de seguimiento sobre su reseña",
  "services.type.up_selling": "Add-On",
  "services.type.items_sales": "Productos",
  "services.type.gift_store": "Tienda de Regalos",
  "services.housekeeping.horary":
    "Recuerde que el horario para solicitar la limpieza de habitación es de 7 a 14hs. En caso contrario no se limpiará su habitación.",
  "services.housekeeping.horary-costa-galana":
    "Recuerde que el horario para solicitar la limpieza de habitación es de 7 a 17hs.",
  "services.housekeeping.do-not-clean-today": "No limpiar la habitación hoy",
  "services.housekeeping.do-not-change-towels": "No cambiar toallas hoy",
  "services.housekeeping.button-title": "Enviar solicitud",
  "services.donotdisturb.button-title-activate":
    "Activar modo <b>NO MOLESTAR</b>",
  "services.donotdisturb.button-title-disable":
    "Desactivar modo <b>NO MOLESTAR</b>",
  "services.donotdisturb.extra-info":
    "Mientras mantenga el estado activo de <b>\"NO MOLESTAR\"</b> no será posible hacer la limpieza ni responder a sus solicitudes.",
  "services.do-not-change-towels": "No cambiar las toallas",
  "services.sent-text":
    "<b>Solicitud Enviada!</b> En cuanto sea procesada será notificado, también puede hacer seguimiento desde su pantalla de <b>Panel de Control</b>. ",
  "services.go-to-requests": "Mi estadía",
  "services.go-to-home": "Ir a Inicio",
  "services.status.pending": "Pendiente",
  "services.status.observed": "Observado",
  "services.status.accepted": "Aceptado",
  "services.status.in_progress": "En Proceso",
  "services.status.in_transit": "En Camino",
  "services.status.done": "Completo",
  "services.status.canceled": "Cancelado",
  "services.status.on_hold": "Pendiente",
  "services.status.seated": "Presente",
  "services.status.confirmed": "Confirmado",
  "services.active-request": "Hay {0} solicitud activa!",
  "services.active-requests": "Hay {0} solicitudes activas!",
  "select...": "Seleccione...",
  "services.confirm-request": "¿Está tu pedido completo?",

  "smartlocks.swipe-to-open": "DESLIZAR PARA ABRIR",

  "smartlocks.pin-code-arosa-explanation": "Luego de ingresar el PIN CODE, debe presionar los botones # o ↵ (enter) para confirmar.",
  "status.messages": "Tienes mensajes!",
  "status.no_messages": "Aún no hemos respondido a su consulta sobre este asunto.Nos pondremos en contacto con usted en breve.",
  "status.more": "Más sobre tu estadía",
  "status.faqs": "Preguntas Frecuentes",
  "status.faqs_description": "Toda la información en un solo lugar",
  "status.contact": "Contáctanos",
  "status.contact_whatsapp": "Escríbenos un WhatsApp",
  "status.contact_description": "¡Estamos aquí para ayudarte!",
  "status.settings.btnDescription_facilities_arosa":"Grandes ofertas de nuestros partners",
  "status.checkin_alert": "Hay novedades en tu Check-in",
  "status.checkin_alert_offgrid": "Neuigkeiten zu deinem Check-in",
  "status.checkin_edit": "Modificar información de check in",
  "status.checkout_description": "Registrar tu salida",
  "status.stay_description": "Información sobre tu estadía",
  "status.stay.info": "Estadía",
  "status.checkin.chat": "Mensajes de Check-in",
  "status.checkin.chat-desc": "Mensajes durante tu proceso de check-in",
  "status.settings": "Avisos",
  "status.settings_description": "Habilitar avisos y notificaciones",
  "status.wifi": "WiFi",
  "status.wifi_description": "Acceso a WiFi",
  "status.wifi_name": "Nombre de la red",
  "status.wifi_password": "Contraseña",
  "status.wifi_no_password": "Ninguna (red abierta)",
  "status.garbage": "Instrucciones para la eliminación de basura",
  "status.parking_info": "Instrucciones de estacionamiento",
  "status.garbage_description": "Todo lo que necesitas saber",
  "status.extra-bed": "Instrucciones cama extra",
  "status.extra-bed_description": "Mira cómo preparar tu cama extra.",
  "status.parking_info_description": "Todo lo que necesitas saber",
  "status.access_code": "Códigos de acceso",
  "status.room_access_code": "Códigos de acceso a la habitación",
  "status.room_keys": "Llaves de la habitación",
  "status.room_keys_description": "Puede recogerlas en las cajas de llaves ubicadas en el hall",
  "status.room_keys_description_becozy": "Puede recogerlas en las cajas de llaves ubicadas en la puerta de la habitación",
  "status.room_keycard": "Tarjeta llave de la habitación",
  "status.room_keycard_description": "Solo recógelas en recepción",
  "status.apartment_keys": "Llaves del departamento",
  "status.apartment_keys_description": "Simplemente recoja sus llaves en la caja de llaves en la entrada principal",
  "status.access_code_one": "Código de acceso",
  "status.access_code.pin_code": "Código PIN",
  "status.access_code_hostz": "Códigos de acceso a los apartamentos",
  "status.access_information": "Información de acceso",
  "status.access_information_extramsg_steiners": "La recepción está abierta todos los días entre las {0} y las {1} y se encuentra después de la puerta de entrada principal, a la izquierda",
  "status.access_information_description": "Todo lo que necesita para acceder a la propiedad",
  "status.access_code_description": "Información de acceso",
  "status.access_code.main_entrance": "Puerta de entrada",
  "status.access_code.main_door": "Código de acceso de entrada principal",
  "status.access_code.room_door": "Código de caja de seguridad de la habitación",
  "status.access_code.ladder": "Código de escalera",

  "status.access_information.access_to_room_themyde": "Acceso a su departamento",
  "status.access_code.ladder_themyde": "Puerta de entrada principal / Código de escalera",

  "status.access_information.access_to_hotel": "Acceso al hotel",
  "status.access_information.accesses_swissstay": "Accesos",
  "status.access_information.access_to_room": "Acceso a tu habitación",

  "status.access_code.main_entrance_themyde": "DOORS & ENTRYWAYS",
  "status.access_information.access_to_room_cover": "Durante la estadía encontrará aquí las instrucciones para obtener las llaves de acceso",
  "status.access_information.access_to_room_cover_arosa": "Disponible a las 16hs",
  "status.access_information.access_to_room_cover_sigma": "Disponible a las 16hs",

  "status.access_information.access_to_room_description_cozy": "Obtén tu tarjeta de acceso de las cajas verdes (Keynest) en el lobby.",
  "status.access_information.main_entrance_description_steiners": "La puerta está abierta durante el día. <br>Si está cerrada, por favor usa el código de abajo para abrir la CAJA DE LLAVES N.1 y utiliza la tarjeta digital dentro para abrir la puerta principal.",
  "status.access_information.access_to_room_description_steiners": "Consigue tu tarjeta-llave de las cajas de llaves verdes ubicadas en el 2do piso.",

  "status.access_instructions": "Instrucciones de acceso",
  "status.access_instructions_description": "Su procedimiento de acceso",
  "status.access_code.key_collection_code": "Código de recogida de llaves",
  "status.access_code.key_dropoff_code": "Código de devolución de llaves",
  "status.access_code.key_dropoff": "Devolución de llaves",
  "status.access_code.key_dropoff_instructions": "Deja la llave en la caja negra al lado de la caja verde donde recogiste las llaves.",  
  "status.access_code.key_card_collection_code": "Código de recogida de tarjeta",
  "status.access_code.key_card_dropoff_code": "Código de devolución de tarjeta",

  "status.access_information.before_checkin": "Los datos de acceso estarán disponibles el día del check-in.",
  "status.access_information.before_checkin_with_hours": "El código de la puerta principal del hotel estará visible a partir de las {0} del día del check-in. Los detalles de tu habitación (número y código de la caja de llaves) estarán disponibles a partir de las {1} del mismo día.",
  "status.access_information.before_checkin_with_hours_themyde": "Podrás ver tu información de acceso a las {0} (hora de check-in)",
  "status.access_information.before_checkin_with_hours_cozy": "La información de acceso estará disponible el día del check-in a las {0}, solo si se ha completado el formulario de check-in y se ha realizado el pago (incluyendo el depósito de seguridad de {1}).",
  "status.access_information.before_checkin_with_hours_steiners": "La información de acceso estará disponible el día del check-in a las {0}, solo si se ha completado el formulario de check-in y se ha realizado el pago (incluyendo el depósito de seguridad de {1}). Si acabas de pagar la reserva y la hora de registro ya ha pasado, por favor, espera de 3 a 5 minutos para que la transacción sea procesada, y una vez aprobada, la información estará visible.",
  "status.access_information.before_checkin_with_hours_no_sd": "La información de acceso estará disponible el día del check-in a las {0}, solo si se ha completado el formulario de check-in y se ha realizado el pago.",
  "status.access_information.before_checkin_main": "Te damos la bienvenida a partir de las {0} de la mañana para que disfrutes de las instalaciones del hotel. También podés dejar tu equipaje en el área de guardado mientras esperás que tu habitación esté lista a las {1}. Los detalles de tu habitación se compartirán a las {1}.",
  "status.access_information.before_checkin_room": "El código de la puerta principal del hotel estará visible a partir de las {0} del día del check-in. Los detalles de tu habitación (número y código de la caja de llaves) estarán disponibles a partir de las {1} del mismo día.",
  "status.access_information.after_checkin": "Tu estadía ha finalizado y los datos de acceso ya no están disponibles. ¡Gracias por habernos visitado! Esperamos darte la bienvenida nuevamente muy pronto.",
  "status.access_information.main_entrance": "Entrada principal",
  "status.access_information.main_entrance_code": "Código de entrada principal",
  "status.access_information.main_entrance_code_sigma": "Código de entrada principal & trasera",
  "status.access_information.main_entrance_code_swissstay": "Acceso principal",
  "status.access_information.main_entrance_code_and_skiroom_code": "Código de entrada principal & Código de sala de esquí",
  "status.access_information.room_keybox_code": "Código de la caja de llaves (ubicada junto a la puerta de tu habitación)",
  "status.access_information.room_keybox_code_arosa": "Código de la caja de llaves (la caja de llaves está ubicada EN LA PUERTA DE TU HABITACIÓN)",
  "status.access_information.please_use_main_key": "Por favor, use la LLAVE PRINCIPAL",
  "status.access_information.link_modal_video": "Mira este breve video para ver cómo funciona el check-in",
  "status.access_information.link_modal_video_themyde": "Mira este breve video para ver cómo funciona el check-in",
  "status.access_information.title_modal_video": "Cómo usar",
  "status.access_information.room_lock_box_code": "Código de la caja de llaves",
  "status.access_information.room_lock_box_location": "Ubicación de la caja de llaves",

  "status.location": "Ubicación",
  "status.location_description": "Obtenga indicaciones para llegar a la propiedad.",
  "status.location_description_swissstay": "Obtén indicaciones para llegar al apartamento aquí.",
  "status.parking": "Estacionamiento",
  "status.parking_description": "Acceso y reglas",

  "bookable.limit": "Reservar antes de ",

  "account.add-device": "Agregar Disp.",
  "account.stay": "Estadía",
  "account.room": "Habitación",
  "account.more-info": "Más Info",
  "account.guest": "Huésped",
  "account.charges": "Cargos",
  "account.payments": "Pagos",
  "account.accommodation": "Estadía",
  "account.accommodation_description": "Noche de estadía",
  "account.citytax": "Impuesto municipal",
  "account.foodandbeverages": "Comida & Bebidas",
  "account.foodandbeverages_description":
    "Consumos en el bar, restaurant, etc.",
  "account.other": "Otros Cargos",
  "account.other_description": "Otros cargos asociados a la estadía",
  "account.download": "Descargar",
  "account.invoices": "Facturas",
  "account.balance": "Balance",
  "account.chat": "Si tiene preguntas sobre la factura, no dude en contactarnos.",


  "review.rate": "Su valoración es:",
  "review.rate_us": "Califiquenos",
  "review.thanks": "Gracias por su valoración!",
  "review.extra_rate": "Reseñas Adicionales",
  "review.extra_rate_text": "Estas calificaciones nos ayudan a mejorar nuestro servicio",
  "review.sending_response": "Enviando respuesta…",
  "review.rate-placeholder": "Escriba su comentario aquí...",
  "review.already-rated": "Gracias por calificarnos, tu opinión es muy valiosa",
  "review.already-rated-button": "Me gustaría cambiar mi calificación.",
  "review.average": "Promedio",
  "review.general": "General:",
  "review.contact": "Por favor, nos gustaría que nos deje su contacto para poder responderle sobre su reseña.",
  "review.flow_ok": "OK",
  "review.flow_submit": "Enviar",
  "review.flow_required_hint": "Responde esta pregunta para continuar.",
  "review.rating_scale_hint": "1 estrella es muy mala, 5 es excelente",
  "review.validation_name_min": "El nombre debe tener al menos 3 caracteres.",
  "review.validation_email": "Introduce un correo electrónico válido.",
  "review.validation_phone": "El teléfono debe tener al menos 6 dígitos.",
  "review.screen_title": "Reseña",
  "review.flow_type_rating": "Valoración",
  "review.flow_type_single_choice": "Selección simple",
  "review.flow_type_opinion_scale": "Escala de opinión",
  "review.flow_type_ranking": "Ranking",
  "review.flow_type_landing": "Landing",

  "request.detail-title": "Detalle de la Solicitud",
  "request.delivery-point": "Punto de Entrega",
  "request.your-request": "Tu Pedido",
  "request.customize_next": "Personalizalo en la siguiente pantalla",
  "request.continue_customize": "Continuar y Personalizar",
  "request.products_not_available": "Productos no disponibles en este horario",
  "request.product_not_available": "Producto no disponible en este horario",
  "request.available-time": "Producto disponible en los horarios",
  "request.item-out-of-hours": "Producto no disponible en este horario",
  "request.available-time-from-to": "{0} a {1}hs",
  "request.product": "Producto",
  "request.products": "Productos",
  "request.creating-order": "Creando pedido",
  "request.creating-order-title": "Estamos generando tu pedido",
  "request.creating-order-description": "Estamos enviando tu pedido al hotel. Esto demora solo unos segundos.",
  "request.order-created": "Pedido creado",
  "request.order-created-title": "Pedido creado con exito",
  "request.order-created-description": "Tu pedido ya fue registrado. En un instante te llevamos al detalle para que puedas seguirlo.",
  "request.redirecting-to-order": "Redirigiendo al detalle en",
  "request.view-order-now": "Ver pedido ahora",
  "request.status-pending": "Pendiente",
  "request.confirm-cancel": "¿Está seguro que desea cancelar su pedido?",
  "request.only-one-for-type":
    "Sólo puedes tener una solicitud abierta de este tipo!",
  "request.lost_objects.observation":
    "Describe aquí los objetos que has perdido en detalle y cuándo y dónde podrías haberlos perdido",
  "request.generic.observation": "Si desea deje un comentario aquí",
  "request.general.observation": "Por favor, ¡díganos cómo podemos ayudarlo hoy!",
  "request.car_valet.observation": "Indíquenos cómo podemos ayudarlo con su vehículo...",
  "request.tray_collection.observation": "¿Alguna instrucción especial para la recogida?",
  "request.breakage_report.observation": "Por favor, indíquenos qué está roto o no funciona correctamente",
  "request.housekeeping.observation": "Por favor, infórmenos si tiene algún requisito especial aquí",
  "request.feedback.feedback": "Por favor, comentenos en que podemos mejorar...",
  "public.personal-information": "Datos personales",
  "public.dashboard.cgbeach.public_cart": "Realizar pedido",
  "public.input.number": "Número",
  "services.type.beach_service": "Serv. de playa",
  "service.type.request": "Solicitud",

  "request.option": "Opción",
  "request.observations": "Comentarios",
  "request.observations-placeholder": "Escriba sus observaciones intentaremos seguir al pie de la letra",
  "request.create.comment": "Dejar un comentario sobre su pedido",
  "request.reserved-days": "Días Reservados",

  "notifications.enable": "Habilitar Notificaciones",
  "notifications.not_now": "Ahora no",
  "notifications.accept":
    "<b>Importante:</b> Habilite las notificaciones para que pueda recibir actualizaciones en tiempo real del estado de sus solicitudes.",
  "notifications.accepted":
    "<b class=\"text-success\">Notificaciones Activadas!</b> A partir de ahora recibirá notificaciones en tiempo real de su proceso de Check-in y de sus solicitudes durante la estadía.",
  "notifications.blocked":
    "<b class=\"text-danger\">Notificaciones Bloqueadas!</b> Permita las notificaciones para que podamos enviarle  notificaciones importantes sobre el estado de sus solicitudes! Haga clic en el icono de candado en la barra de direcciones de su navegador y active las notificaciones. Gracias.",
  "notifications.confirm-continue":
    "<b>Estás seguro de que quieres continuar?</b> Las notificaciones mejorarán tu experiencia mientras nos visitas.",
  "notifications.empty-title": "No tienes Notificaciones",
  "notifications.empty-text":
    "Cuando recibas una notificación se mostrará aquí.",
  "notificacions.title": "Notificaciones",
  "notifications.link.make-the-review": "Hacer Reseña",


  "stay.add-device-use-qr":
    "Utiliza el QR desde otro dispositivo para agregarlo a la estadía.",


  "yup.required": "El campo es requerido",
  "yup.only-letters": "Solo se permiten letras",
  "yup.only-numbers": "Solo se permiten números",
  "yup.only-numbers-and-letters": "Sólo números o letras",
  "yup.minimal-6-digits": "Debe contener mínimo 6 dígitos",
  "yup.minimal-7-digits": "Debe contener mínimo 7 dígitos",
  "yup.minimal-2-letters": "Debe contener mínimo 2 letras",
  "yup.maximal-50-letters": "Debe contener máximo 50 letras",
  "yup.maximal-12-digits": "Debe contener máximo 12 dígitos",
  "yup.maximal-25-digits": "Debe contener mÁs de 25 dígitos",
  "yup.wrong-date": "Fecha No Válida",
  "yup.please-review": "Por favor, revise este valor",
  "yup.email-invalid-format": "Formato incorrecto de e-mail",

  "toast.do-not-disturb-mode-active-title": "Modo \"No Molestar\" activo",
  "toast.do-not-disturb-mode-active-text":
    "Para poder hacer un pedido debe desactivar el modo NO Molestar!",
  "toast.do-not-disturb-mode-active-link": "Desactivar",

  "payments.summary-of-charges": "Resumen de Cargos",
  "payments.guarantee-deposit-paid": "Su reserva ya tiene un depósito de garantía activo.",
  "payments.balance-paid": "Su reserva no tiene saldo pendiente de pago.",
  "payments.total-to-pay": "Total a pagar",
  "payments.pay": "Pagar Ahora",
  "payments.retry-pay": "Reintentar Pago",
  "payments.items-pay-with-deposit": "A continuación se enumeran los cargos a pagar:",
  "payments.guarantee-deposit": "Depósito de seguridad",
  "payments.guarantee-deposit-desc": "Este importe quedará retenido pero no se cargará a su tarjeta de crédito.",
  "payments.select-items-pay": "Seleccione los ítems que desea pagar",
  "payments.payment-ok": "Su pago se realizó correctamente",
  "payments.payment-error": "Se produjo un error al intentar realizar el pago",
  "payments.payment-not-authorised": "Pago no autorizado",
  "payments.pending-confirmation": "Estamos confirmando tu pago con el banco. No cierres esta pantalla.",
  "payments.pending-timeout": "La confirmación del pago está tardando más de lo habitual. Intenta de nuevo o contacta con recepción.",
  "payments.payment-unavailable-continue": "Pago no disponible en este momento, puede continuar con el webcheckin y pagar luego.",
  "payments.loading-component": "Cargando componente de pago...",
  "payments.later": "Voy a pagar luego",
  "payments.confirm-pay-later": "Confirmarás el pedido y pagarás más tarde. Usa el botón Comprar de abajo.",
  "payments.back-to-pay-later": "elegir pagar después",
  "payments.msg_guarantee": "En Black Summit Laax, solicitamos un depósito de seguridad para garantizar una estadía segura y placentera para todos nuestros huéspedes. Este depósito actúa como medida de precaución para cubrir posibles daños a la propiedad, los muebles o las comodidades, así como cargos imprevistos, como limpieza adicional o salidas tardías. El depósito se liberará 7 días después de la salida, una vez que se haya inspeccionado la propiedad y no se hayan encontrado problemas. El reembolso se procesará a su método de pago original.",
  "payments.msg_guarantee_72hs": "Recuerde que deberá abonar un depósito de {0} CHF como medida obligatoria 72 horas antes de su llegada. Recibirá una notificación por correo electrónico como recordatorio.",
  "payments.older": "Pago anterior",

  "facilities.Carta_Belleza": "Carta de Belleza",
  "spa.Carta_Tratamientos": "Menú de Masajes",
  "facilities.Carta_SPA": "Menú",
  "home.chat-24-7": "Chat 24/7",
  "home.book-a-room": "Reservar una habitación",
  "home.book-an-apartment": "Reservar un apartamento",

  "door.main": "Principal",
  "door.back": "Trasera",
  "room.address": "Dirección",
  "room.number": "Número de habitación",
  "room.floor": "Piso de la habitación",
  "apartment.address": "Dirección del departamento",
  "apartment.number": "Departamento",
  "apartment.floor": "Piso del departamento",

  "public.bookable.init": "Por favor, seleccione la cantidad de personas y la fecha que desea consultar disponibilidad",
  "public.bookable.sent-text": "<b>Solicitud Enviada!</b> <br/>En cuanto sea procesada será notificado del estado de su reserva.",
  "public.bookable.fill-data": "Por favor, complete los siguientes datos para finalizar su reserva del día:",
  "public.edit-hour": "Modificar horario",
  "public.input.name-and-surname": "Nombre y Apellido",
  "public.input.phone": "Teléfono",
  "public.input.email": "Email",
  "public.input.observations": "Comentarios",
  "public.bookable.gala-experience": "¿Cuenta con la experiencia de haber asistido a una Gala del Hotel?",
  "public.bookable.gala-experience.required": "Por favor, seleccione una opción",
  "public.bookable.list-empty": "No existen servicios disponibles para hacer reservas.",
  "public.dashboard.home": "Inicio",
  "public.dashboard.services": "Servicios",
  "public.dashboard.my-profile": "Mi perfil",
  "public.reservation.confirmed-at": "Aceptado el día {date}",
  "public.request.status.canceled-msg": "La solicitud ha sido cancelada.",
  "public.input.location": "Ubicación",
  "public.input.location.arena": "Sombrilla arena",
  "public.input.location.piscina": "Sombrilla piscina",
  "public.input.location.carpa": "Carpa",
  "public.input.tent": "Número de carpa",
  "public.personal-information": "Datos personales",
  "general.processing-request": "Procesando solicitud...",

  "complete-to-web-checkin": "Web Check-In",

  "services.make-your-reservation": "Haga su reserva",  
  "services.make-your-reservation-button": "Reserve nuestros servicios",

  "public.reservation.not-found": "No se encontró el detalle de la reserva",
  "public.reservation.welcome": "Hola {0}, estos son los datos de tu reserva:",
  "public.reservation.date-and-hour": "Fecha y hora",
  "public.reservation.people": "Personas",
  "public.reservation.adults": "Adultos",
  "public.reservation.adult": "Adulto",
  "public.reservation.children": "Niños",
  "public.reservation.child": "Niño",
  "public.reservation.state": "Estado",
  "public.reservation.status.remember-status": "Aceptado",
  "public.request.cancel-assistance": "Cancelar asistencia",
  "public.request.cancel-request": "Cancelar",
  "public.reservation.observations": "Observaciones",
  "public.dashboard.logout": "Cerrar sesión",
  "public.dashboard.welcome": "¡Bienvenido, {0}!",
  "public.dashboard.no-reservations": "No tienes reservas activas",
  "public.reservation.view-reservations": "Ver todas mis reservas",
  "public.reservation.confirm": "Confirmar",
  "public.reservation.confirm_msg": "Podrás confirmar tu reserva hasta 72hs antes del horario de inicio.",
  "public.reservation.confirmated-at": "Reserva confirmada el",
  "public.reservation.status.validating": "Procesando solicitud",
  "public.request.forbidden.title": "No se puede mostrar esta solicitud",
  "public.request.forbidden.description": "La solicitud no corresponde al usuario {0}. Si desea continuar esta acción, se cerrará su sesión actual y se redirigirá a la nueva.",
  "public.request.forbidden.button": "Ir a mis solicitudes",
  "public.reservation.status.accepted": "Aceptado",
  "public.request.forbidden.continue-button": "Continuar",
  "public.dashboard.requests": "Solicitudes",
  "public.dashboard.not-found": "No se encontró el perfil de usuario",
  "public.dashboard.my-data": "Mis datos",
  "public.dashboard.name": "Nombre completo",
  "public.dashboard.email": "Email",
  "public.dashboard.phone": "Teléfono",
  "public.dashboard.my-reservations": "Mis reservas",
  "public.dashboard.my-requests": "Mis solicitudes",
  "public.request.not-found": "Detalles de la solicitud no encontrados",
  "public.request.welcome": "Hola {0}, aquí están los detalles de tu solicitud:",
  "public.request.date-and-hour": "Fecha y hora",
  "public.request.people": "Personas",
  "public.request.passengers": "Pasajeros",
  "public.request.title": "Detalle del pedido",
  "public.request.state": "Estado",
  "public.request.observations": "Observaciones",
  "public.request.additional-observations": "Observaciones adicionales",
  "public.request.view-requests": "Ver todas mis solicitudes",
  "public.request.accept-request": "Aceptar solicitud",
  "public.request.confirm-assistance": "Confirmar asistencia",
  "public.reservation.status.accepted": "Solicitud aceptada",
  "public.reservation.status.canceled": "Cancelado",
  "public.reservation.status.pending": "Requiere confirmación",
  "public.reservation.status.confirmed": "Confirmado",
  "public.request.status.validating-msg": "Su solicitud está siendo procesada, le notificaremos cuando esté lista.",
  "public.request.confirmed": "Solicitud confirmada el",
  "public.dashboard.go-to-my-reservations": "Ir a mis reservas",
  "public.request.payment-status.pay-again": "Reintentar pago",
  "public.request.payment-status.not-captured": "No se pudo capturar el pago. Por favor, reinténtelo nuevamente para poder finalizar su solicitud.",
  "menu.all": "Todos",
  "menu.search": "Buscar en el menú...",
  "menu.search_room_service": "Buscar producto...",
  "menu.search_restaurant": "Buscar en Restaurant...",
  "menu.category": "Categoría {0}",
  "menu.vegetarian": "Vegetariano",
  "menu.gluten_free": "Sin Gluten",
  "menu.items_not_found": "No hay items configurados para este servicio. Consulte con el administrador.",
  "menu.fail_laod_items": "Error al cargar los items del servicio. Intente nuevamente más tarde.",

  "menu.price_without_taxes": "Precio sin impuestos Nacionales:",
  "no-hours.disabled.day": "Este servicio no estará disponible durante el día de hoy.",
  "no-hours.disabled.general": "Esta sección se encuentra cerrada para el horario actual",
  "no-hours.disabled.slot": "Este servicio no se encuentra disponible en este momento. Inténtelo nuevamente más tarde.",
  "general.invalid-dates": "No hay tarifas disponibles para períodos superiores a {0} días.",
  "upselling.no-availability": "Por el momento, esta opción no está disponible para su estadía.",  
  "general.selected-days": "Días seleccionados",
  "general.selected-day": "Día seleccionado",
  "general.day": "Día",
  "general.no-rates-available-for-selected-dates": "No hay tarifas disponibles para los días seleccionados.",
  "general.must-select-passengers": "Seleccione cantidad y pasajeros en al menos una categoría de pasajeros.",
  "general.payment-method": "Método de pago",
  "general.select-passengers": "Seleccionar pasajeros", 
  "general.select-passenger": "Seleccionar pasajero",

  "days.sunday": "Domingo",
  "days.monday": "Lunes",
  "days.tuesday": "Martes",
  "days.wednesday": "Miércoles",
  "days.thursday": "Jueves",
  "days.friday": "Viernes",
  "days.saturday": "Sábado",

  "public_cart.hours-label": "Horarios de atención",
  "public_cart.no-available-hours": "No hay horarios disponibles",
  "CHECKINS_FOUND_NONE_VALID": "Reserva no habilitada aun para realizar el Check in. Intente nuevamente en fecha de ingreso",
  "CHECKINS_FOUND_MORE_THAN_ONE_VALID": "Hubo un problema al encontrar la reserva por habitación, por favor, intente con código de reserva",
  "CHECKINS_FOUND_NONE_LASTNAME_VALID": "No se pudo encontrar la reserva",
  "kiosk.welcome.subtitle": "Check-in completado exitosamente",
  "kiosk.room": "Habitación",
  "kiosk.checkin": "Check-in",
  "kiosk.checkout": "Check-out",
  "kiosk.download_app": "Escaneé para acceder a los servicios del hotel",
  "kiosk.scan_qr": "Escanea el código QR para acceder a servicios adicionales",
  "kiosk.generating_qr": "Generando QR...",
  "kiosk.redirect_warning": "Te redireccionaremos en {seconds} segundos...",
  "kiosk.go_to_identify": "Finalizar",

  "kiosk.login.title": "Ingresa tu PIN",
  "kiosk.login.description": "Por favor, ingresa el código de acceso para continuar",
  "kiosk.login.button_access": "Acceder",
  "kiosk.login.button_loading": "Cargando...",
  "kiosk.login.error_empty": "Por favor ingresa el PIN",
  "kiosk.login.error_invalid": "PIN incorrecto. Intenta de nuevo.",
  "kiosk.login.error_process": "Error al procesar el login. Intenta de nuevo.",
  "kiosk.login.copyright": "© {year} {hotel}. Todos los derechos reservados.",
  "kiosk.login.pin": "Ingresa tu PIN",
  "kiosk.logout.confirm": "Ingrese su PIN para salir del modo Kiosk",
  "kiosk.logout.title": "Salir del modo Kiosk",
  "kiosk.receiving-info": "Recibiendo información...",
  "kiosk.inactivity-warning-title": "¿Sigue ahí?",
  "kiosk.inactivity-warning-message": "Ha estado inactivo. Si no responde en los próximos segundos, su sesión terminará automáticamente.",
  "kiosk.inactivity-countdown": "Sesión cerrará en",
  "kiosk.inactivity-stay": "Sí, continuar",
  "kiosk.inactivity-logout": "No, cerrar sesión"
};
